import request from '@/utils/request'
import store from '@/store'
// store.getters.userTentant.tenantId
// tenantId 0 管理员 1 厂商 2 经销商 3 区域
// 查询派单列表分页
export function fetchList(query) {
    return request({
        url: store.getters.userTentant.type == 0 ? '/fix/order/page' : store.getters.userTentant.type == 1 ? '/fix/order/firm' : store.getters.userTentant.type == 2 ? '/fix/order/page' : '/fix/order/region',
        method: 'get',
        params: query,
    })
}

// 查询派单区域
export function fetchRegin(query) {
    return request({
        url: '/fix/order/region',
        method: 'get',
        params: query,
    })
}
// 查询派单详细
export function getObj(id) {
    return request({
        url: '/fix/order/detail?id=' + id,
        method: 'get',
    })
}
// 查询派单详细
export function getObjS(id) {
    return request({
        url: '/fix/order/detail?id=' + id,
        method: 'get',
    })
}
// 筛选员工
export function tenantUser(query) {
    return request({
        url: '/system/user/tenant/employee',
        method: 'get',
        params: query,
    })
}
// 状态
export function statusCount(query) {
    return request({
        url: '/fix/order/status/count',
        method: 'get',
        params: query,
    })
}
// 区域状态
export function reginCount(query) {
    return request({
        url: '/fix/order/region/status/count',
        method: 'get',
        params: query,
    })
}
// 筛选员工
export function pageMy(query) {
    return request({
        url: '/system/tenant/page/my',
        method: 'get',
        params: query,
    })
}
// 试压记录
export function recordPage(query) {
    return request({
        url: '/fix/order/record/list',
        method: 'get',
        params: query,
    })
}
// 新增派单
export function addObj(data) {
    return request({
        url: '/fix/order/add',
        method: 'post',
        data: data,
    })
}
// 新增预约派单
export function addObj1(data) {
    return request({
        url: '/fix/order/add01',
        method: 'post',
        data: data,
    })
}
// 下载验收报告
export function acceptanceReport(data) {
    return request({
        url: '/fix/order/acceptance/report',
        method: 'post',
        data: data,
    })
}
// 重新发送短信
export function sendSms(data) {
    return request({
        url: '/fix/order/send/sms',
        method: 'post',
        data: data,
    })
}
// 生成验收报告
export function acceptance(data) {
    return request({
        url: '/fix/order/acceptance/report',
        method: 'post',
        data: data,
    })
}
// 修改服务订单
export function orderEdit(data) {
    return request({
        url: '/fix/order/edit',
        method: 'post',
        data: data,
    })
}
// 审核服务订单
export function orderExamine(data) {
    return request({
        url: '/fix/order/examine',
        method: 'post',
        data: data,
    })
}
// 修改订单验收员
export function orderSend(data) {
    return request({
        url: '/fix/order/send',
        method: 'post',
        data: data,
    })
}
// 修改vr地址
export function orderVr(data) {
    return request({
        url: '/fix/order/vr',
        method: 'post',
        data: data,
    })
}
// 作废订单
export function orderVoid(data) {
    return request({
        url: '/fix/order/void',
        method: 'post',
        data: data,
    })
}
// 修改派单
export function putObj(data) {
    return request({
        url: '/fix/order/edit',
        method: 'post',
        data: data,
    })
}
// 删除派单
export function delObj(data) {
    return request({
        url: '/fix/model/delete',
        method: 'post',
        data: data,
    })
}
// 禁用派单
export function statusObj(data) {
    return request({
        url: '/fix/model/status',
        method: 'get',
        params: data,
    })
}